<template>
    <v-container fluid>
        <v-row align="center" justify="center">
            <div class="text-center title font-weight-medium">{{$t('Печать счёта-квитанции')}}</div>
        </v-row>
        <v-row align="center" justify="center">
            <div class="text-center subtitle-2">{{$t('Выберите способ получения счёта-квитанции')}}</div>
        </v-row>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
                <div class="text-center">
                    <v-btn
                        rounded
                        color="teal darken-4"
                        dark
                        to="/account"
                    >{{$t('По номеру лицевого счёта')}}</v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
                <div class="text-center">
                    <v-btn
                        rounded
                        color="teal darken-4"
                        dark
                        to="/address"
                    >{{$t('По адресу лицевого счёта')}}</v-btn>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    components: {},
    computed: {},
    mounted() {
        this.$nextTick(() => {
            this.init();
        });
    },
    methods: {
        ...mapActions('print', ['init'])
    }
};
</script>

<style>
.bigBtn {
    font-size: 2.2em;
}
</style>